module.exports = __webpack_public_path__ + "static/scroll2-63b0282cde4c3325af3a164e0994def7.mp4";